export const validTypeMap: { [key: string]: string } = {
  0: 'Invalid',
  1: 'Medium',
  2: 'High',
  3: 'Low',
};

/**
 * <CommonBubble
 *    overlayClassName="dbo-scroll-bubble"
 *    content={ <div className="dbo-scroll-bubble-scroll"></div>}>
 */
export enum ClassSpecial {
  NO_FILTER = 'dbo-no-invert',
  FILTER_NONE = 'dbo-filter-none',
  TAB_NONE = 'dbo-hide-tabs',
  BUBBLE_SCROLL = 'dbo-scroll-bubble',
  BUBBLE_SCROLL_CONTENT = 'dbo-scroll-bubble-scroll',
  BUBBLE_UNLIMITED_WIDTH = 'dbo-bubble-unlimited-width',
  CHART_TOOLTIP_SCROLL = 'dbo-scroll-formatter',
  TABLE_HIDE_CHECKBOX = 'dbo-table-hide-checkbox-wrapper',
}

export enum StyleSpecial {
  SCROLL = 'scrollMarginTop',
}
